import { screen } from 'components/styles/variables';
import { DetailedHTMLProps, ButtonHTMLAttributes } from 'react';
import rightArrow from 'public/static/images/vdp/right-arrow.svg';
import leftArrow from 'public/static/images/vdp/left-arrow.svg';

export enum Directions {
  Left,
  Right,
}

export interface ArrowProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  direction: Directions;
  alt: string;
}

export function Arrow({ direction, alt, ...otherProps }: ArrowProps): JSX.Element {
  const isLeft = direction === Directions.Left;

  return (
    <button {...otherProps}>
      <img src={isLeft ? leftArrow : rightArrow} alt={alt} />
      <style jsx>{`
        button :global(.arrow) {
          color: white;
        }

        button {
          height: 72px;
          width: 36px;
          border-radius: 8px;
          border: none;
          display: flex;
          justify-content: center;
          align-items: center;
          background: none;
          outline: none;
          display: none;
          cursor: pointer;
        }

        @media (min-width: ${screen.mdMin}) {
          button {
            display: flex;
          }
        }

        button:hover {
          cursor: pointer;
          background: rgba(0, 0, 0, 0.6);
        }

        .transparent-hover:hover {
          background: rgba(0, 0, 0, 0);
        }

        img {
          filter: drop-shadow(0.001px 0.001px 1px black);
        }
      `}</style>
    </button>
  );
}
